import type { Properties } from './analyticsTypes';
import analytics from './segment';

/**
 * Identify the user to Segment
 *
 * @param userUid The user's Analytics UID
 * @param traits The entitlements User object
 */
export const identify = (userAnalyticsId: string, traits?: Properties) => {
  analytics.identify(userAnalyticsId, traits);
};
/**
 * Clear Segment's persisted identity for this browser.
 *
 * Call when the browser stops belonging to the identified user — on sign-out, or on
 * a page that has resolved to no authenticated user. Without it the identity
 * persists in cookies on `.autodesk.com` for up to a year and is inherited by
 * whoever uses the browser next.
 *
 * Drops the anonymous id as well: Segment's own `reset()` always does, so it cannot
 * be preserved by clearing selectively. Preserving it requires capturing and restoring
 * the id around `reset()`, which will land with the first caller that needs it.
 *
 * @returns Nothing.
 */
export const resetIdentity = () => {
  analytics.resetIdentity();
};
export const setBaseProperties = analytics.setBaseProperties;
export const track = analytics.track;
export const waitForBaseProperties = analytics.waitForBaseProperties;
export const getBaseProperty = analytics.getBaseProperty;
export const load = analytics.load;

export { type Properties };
export { default as MockAnalyticsStore } from './MockAnalyticsStore';
